import React from "react"
import {withStyles} from "@material-ui/core"
import PropTypes from "prop-types"

const styles = () => ({
  root: {
    margin: `32px`,
  },
  details: {
    whiteSpace: `pre-wrap`,
  },
})

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      error: null,
      errorInfo: null,
    }
  }
  componentDidCatch(error, errorInfo) {
    this.setState({
      error,
      errorInfo,
    })
  }

  render() {
    const {classes} = this.props
    if (this.state.errorInfo) {
      return (
        <div className={classes.root}>
          <h2>Something went wrong</h2>
          <details className={classes.details}>
            {this.state.error && this.state.error.toString()}
            <br />
            {this.state.errorInfo.componentStack}
          </details>
        </div>
      )
    }
    return this.props.children
  }
}

ErrorBoundary.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(ErrorBoundary)
